import { useMutation } from "@tanstack/react-query";
import { register } from "../api/authApi";

// Registro de usuario (sign-up).
export const useRegister = () => useMutation({ mutationFn: register });
